import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { ContainerMixin } from 'vue-slicksort';
let SortableList = class SortableList extends Vue {
};
SortableList = tslib_1.__decorate([
    Component({
        name: 'SortableList',
        mixins: [ContainerMixin],
    })
], SortableList);
export default SortableList;
